module.exports = __webpack_public_path__ + "img/qc6.80a56fba.png";